module.exports = __webpack_public_path__ + "img/symbol_app_03.4418f592.png";